// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"e5887826","155":"d2a80d67"}[chunkId] + ".chunk.js";
};